export const borderRadius = {
  small: 8,
  default: 16,
  image: 20,
  button: 8,
}
